export default __webpack_public_path__ + "static/media/bitcoin-cash-bch-logo.dcaaa7f0.svg";